import { render, staticRenderFns } from "./OtpProblemsPanel.vue?vue&type=template&id=45f27d20&scoped=true"
import script from "./OtpProblemsPanel.vue?vue&type=script&lang=js"
export * from "./OtpProblemsPanel.vue?vue&type=script&lang=js"
import style0 from "./OtpProblemsPanel.vue?vue&type=style&index=0&id=45f27d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f27d20",
  null
  
)

export default component.exports